<template>
  <div class="gou-flex-container gou-flex-row gou-flex-horiz-apart" :class="{ 'header-web-index':$route.name === 'Index' && platform === 'web', 'header-client-index': $route.name === 'Index' && platform !== 'web', 'header':$route.name !== 'Index' }">
    <div class="left gou-flex-container gou-flex-row" :class="($route.name !== 'Index' || platform !== 'web') ? 'gou-flex-verti-center' : 'gou-flex-verti-top'">
      <div v-if="$route.name === 'Index' && platform === 'web'">
        <img
          class="logo"
          :src="require('@/assets/img/logo-title.png')"
          alt=""
        />
        <span class="logo-title">Hello,欢迎使用广联达数维共享云盘！</span>
      </div>
      <div class="enterprise-logo" v-else>
        <span class="logo-img" :class="{'active-logo-img':['Index', 'OpenSpaceList'].includes($route.name)}" @click="returnHome">
          <svg t="1727664728404" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1966" width="200" height="200"><path d="M511.808 92.16L92.16 428.8v502.528h295.424v-283.84h248.32v283.84h295.424V428.864L511.808 92.16z" p-id="1967"></path></svg>
        </span>
        <template v-if="!['Index', 'OpenSpaceList'].includes($route.name)">
          <slot name="customContent">
            <span class="breadcrumb" :class="{breadcrumbDetail:isDetailPage}" v-for="item in breadcrumbs" :key="item.name">
            <span v-if="item.isRoute" class="spaceName" @click="returnSpace" :title="item.name">{{ breadcrumbName(item.name) }}</span>
            <template v-else-if="item.slot === 'fileName'">
              <ellipsis-text :text="item.name" />
            </template>
            <span v-else :class="item.class">{{ item.name }}</span>
          </span>
          </slot>
        </template>
      </div>
      <div class="right-header">
        <div class="little-banner">
          <img class="little-banner-img" src="../../assets/img/header-banner-1229.png" height="28" />
        </div>
        <div class="plugin-setting-container" v-if="platform !== 'web'" @click="showPluginSetting">
          <img class="icon-img" src="../../assets/img/icon_shezhi.svg" width="20" alt="" />
          <span>插件设置</span>
        </div>
        <div class="icon-container">
          <el-tooltip class="icon-item" effect="dark" content="广小二" placement="bottom">
            <img src="../../assets/img/icon_guangxiaoer.svg" width="20" @click="openRobot" alt="" />
          </el-tooltip>
          <el-tooltip class="icon-item" effect="dark" content="反馈" placement="bottom">
            <img src="../../assets/img/icon_feedback.svg" width="20" @click="toFeedback" alt="" />
          </el-tooltip>
          <el-tooltip class="icon-item" effect="dark" content="帮助文档" placement="bottom">
            <img src="../../assets/img/icon_help.svg" width="20" @click="toHelp" alt="" />
          </el-tooltip>
        </div>
        <div ref="headerCollapse" class="user-info">
          <div class="user-brief-info gjw-flex-container gjw-flex-row gjw-flex-verti-center">
            <img :src="$hosts.static(user.avatar)" />
            <span class="user-name" :title="userName || user.name">{{ userName || user.name }}</span>
            <i class="el-icon-caret-bottom"></i>
          </div>
          <Collapse>
            <template>
              <gjw-collapse>
                <ul
                  v-show="showCollapse"
                  ref="menu"
                  class="user-menu gjw-shadow-small"
                  :style="{ top: $route.name === 'Index' ? (platform === 'web'? '50px' : '40px') : '40px' }"
                >
                  <li class="user-info-menu-item">
                    <img :src="$hosts.static(user.avatar)" />
                    <span class="user-name" :title="userName || user.name">
                      {{ userName || user.name }}</span>
                    <span
                      class="user-mobile"
                      :title="user.mobile"
                      >手机号：{{ user.mobile }}</span>
                  </li>
                  <div class="user-action">
                    <li class="user-menu-item">
                      <i class="&#xe780;" />

                      <a @click="userInfo()" target="_blank">
                        <i class="el-icon-setting"></i>
                        <span>个人信息</span>
                      </a>
                    </li>
                    <li class="user-menu-item" @click="logout()">
                      <i class="&#xe781;" />
                      <svg
                        t="1721801713004"
                        class="icon svg-icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="#495F70"
                        p-id="1527"
                        width="200"
                        height="200"
                      >
                        <path
                          d="M885.952 537.472l0.64-0.704 0.64-0.896 0.448-0.64 0.704-0.96 0.384-0.512a38.912 38.912 0 0 0 0.64-1.024l0.384-0.576a38.4 38.4 0 0 0 0.64-1.024c0-0.192 0.192-0.384 0.256-0.64a38.208 38.208 0 0 0 0.512-0.96l0.384-0.64 0.384-0.96 0.384-0.832a38.4 38.4 0 0 0 0.32-0.832l0.32-0.896 0.256-0.768a40.704 40.704 0 0 0 0.384-1.088l0.192-0.64a36.736 36.736 0 0 0 0.256-1.152l0.192-0.64a36.992 36.992 0 0 0 0.256-1.152c0-0.256 0-0.448 0.128-0.64l0.192-1.216 0.064-0.704 0.128-1.152 0.064-0.96 0.064-0.896a38.4 38.4 0 0 0 0-3.776v-0.896l-0.128-0.96-0.128-1.088-0.064-0.768-0.192-1.216-0.128-0.64-0.256-1.152-0.192-0.64-0.256-1.152-0.192-0.64-0.384-1.088-0.256-0.704-0.32-0.96-0.32-0.832-0.384-0.832-0.384-0.896-0.384-0.64a39.488 39.488 0 0 0-0.512-1.024l-0.32-0.64a34.56 34.56 0 0 0-0.64-1.024c0-0.192-0.192-0.384-0.256-0.512l-0.64-1.088c-0.192-0.128-0.32-0.32-0.384-0.512l-0.768-0.96-0.448-0.64-0.64-0.832-0.64-0.768-0.64-0.64-1.28-1.344-177.6-177.664a38.208 38.208 0 0 0-54.08 54.016l112.384 112.384H431.04a38.208 38.208 0 1 0 0 76.48h333.696l-112.384 112.384a38.208 38.208 0 0 0 54.08 54.08l177.6-177.664 1.28-1.344 0.64-0.64z"
                          p-id="1528"
                        ></path>
                        <path
                          d="M435.008 864.64H191.36V161.28h243.584a42.624 42.624 0 0 0 0-85.248H148.8a42.624 42.624 0 0 0-42.624 42.624v788.608c0 23.552 19.072 42.624 42.624 42.624h286.208a42.624 42.624 0 0 0 0-85.184z"
                          p-id="1529"
                        ></path>
                      </svg>
                      <span>退出登录</span>
                    </li>
                  </div>
                </ul>
              </gjw-collapse>
            </template>
          </Collapse>
        </div>
      </div>
    </div>
    <gjw-dialog
      title="插件设置"
      :show-dialog="dialogVisible"
      :config="{ showFooter: false, width: '560px' }"
      @close="dialogVisible = false">
      <div class="default-cache-path-container">
        <span>默认缓存路径：</span>
        <el-input :value="pluginCachePath" disabled/>
        <el-button v-if="canUpdateCachePath" type="primary" @click="updateCache">修改</el-button>
        <el-button @click="clearCache">清理</el-button>
      </div>
      <div v-if="canUpdateCachePath" class="tip">注：仅可选择空文件夹</div>
    </gjw-dialog>

    <gjw-dialog
      class="progress-dialog"
      :show-dialog="progressVisible"
      :config="{ showFooter: false, width: '300px' }">
      <div class="progress-container">
        <span>正在清理</span>
        <el-progress :percentage="clearCachePercentage" :stroke-width="10" :show-text="false"></el-progress>
      </div>
    </gjw-dialog>
  </div>
</template>

<script>
import Big from 'big.js'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import Collapse from '@/components/common/Collapse'
import GjwCollapse from '@/components/lib/GjwCollapse'
import * as DesktopCache from '@/core/desktopCache'
import EllipsisText from '@/views/file/components/EllipsisText.vue'
import openUrlMixin from '@/mixins/openUrlMixin'
export default {
  mixins: [openUrlMixin],
  components: { EllipsisText, Collapse, GjwCollapse },
  data() {
    return {
      showCollapse: false,
      dialogVisible: false,
      progressVisible: false,
      clearCacheStatus: false,
      clearCachePercentage: 0,
      userName: '',
      defaultCachePath: DesktopCache.businessBasePath(),
      resourceDetailMap: {
        ComponentDetail: 'ComponentList',
        ModuleDetail: 'ModuleList',
        FileModelView: 'File',
      },
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/user',
      userToken: 'user/userToken',
      platform: 'platform',
      pluginCachePath: 'pluginCachePath',
      canUpdateCachePath: 'canUpdateCachePath',
      spacesDetail: 'classifySpace/spacesDetail',
      fileModelView: 'breadCrumbInfo/fileModelView',
      getConfig: 'staticConfig/getConfig',
    }),
    breadcrumbs() {
      const breadcrumbs = []
      breadcrumbs.push({
        name: this.spacesDetail.name,
        isRoute: true,
      })
      const detailNames = Object.keys(this.resourceDetailMap)
      if (detailNames.includes(this.$route.name)) {
        breadcrumbs.push({ name: '>', isRoute: false, routeName: '' })
        if (['ComponentDetail', 'ModuleDetail'].includes(this.$route.name)) {
          breadcrumbs.push({ name: '资源详情', isRoute: false, routeName: '' })
        } else if (this.$route.name === 'FileModelView') {
          const fileInfo = this.fileModelView
          const fileName = fileInfo.fileSuffix ? `${fileInfo.fileName}.${fileInfo.fileSuffix}` : fileInfo.fileName
          breadcrumbs.push({ name: fileName || this.$route.query.title, isRoute: false, routeName: '', slot: 'fileName' })
          breadcrumbs.push({ name: fileInfo.version || this.$route.query.version, isRoute: false, routeName: '', class: 'version-tag' })
        }
      }
      return breadcrumbs
    },
    isDetailPage() {
      const detailNames = Object.keys(this.resourceDetailMap)
      return detailNames.includes(this.$route.name)
    },
  },
  watch: {
    '$route.params': {
      async handler(newVal) {
        if (newVal.spaceId) {
          // 不为空，则需要获取空间信息
          if (!(this.spacesDetail && this.spacesDetail.id) || this.spacesDetail.id !== newVal.spaceId) {
            // spacesDetail 为空 或者 spacesDetail不是路径下的id时 需要获取空间信息
            await this.getSpacesDetail(newVal.spaceId)
          }
        }
      },
      immediate: true,
    },
  },
  created() {
    if (this.platform !== 'web') {
      this.getPluginCachePath()
    }
  },
  async mounted() {
    const data = await this.$api.space.getTeamSpaces({
      member_type: 'CREATOR',
      page_no: 1,
      page_size: 20
    })
    this.userName = data.list[0]?.creatorName
    const collapse = this.$refs.headerCollapse
    if (collapse) {
      collapse.addEventListener(
        'mouseenter',
        () => {
          this.showCollapse = true
        },
        false
      )
      collapse.addEventListener(
        'mouseleave',
        () => {
          this.showCollapse = false
        },
        false
      )
      this.$once('hook:beforeDestroy', () => {
        collapse.removeEventListener('mouseenter', () => {
          this.showCollapse = true
        })
        collapse.removeEventListener('mouseleave', () => {
          this.showCollapse = false
        })
      })
    }
  },
  methods: {
    ...mapMutations({
      setPluginCachePath: 'setPluginCachePath',
    }),
    ...mapActions({
      logoutUserInfo: 'user/logout',
      logoutPlugin: 'user/logoutPlugin',
      getSpacesDetail: 'classifySpace/getSpacesDetail',
    }),
    async openRobot() {
      if (this.user.name) {
        const data = await this.$api.user.getLoginToken()
        document.querySelector('#gr-window iframe').contentWindow.postMessage({
          type: 'plugin-sso-login-token',
          loginToken: data
        }, '*')
      }
      window.GlodonRobotJsSDK.show()
    },
    toFeedback() {
      const url = `${process.env.VUE_APP_GJW_PORTAL_URL}/feedback?source=TeamSpace`
      this.openUrl(url)
    },
    toHelp() {
      const urls = this.getConfig('linkUrls') || {}
      const url = urls.helpUrl
      if (!url) { return }
      this.openUrl(url)
    },
    async userInfo() {
      if (this.platform === 'web') {
        window.open(
          `${process.env.VUE_APP_GJW_PORTAL_URL}/private#/user`,
          '_blank'
        )
      } else {
        const url = await this.$api.user.ssoUrl({ dest: `${process.env.VUE_APP_GJW_PORTAL_URL}/private#/user` })
        await this.$desktopClient.NavigateToBrowser(url)
      }
    },
    async logout() {
      const host = process.env.VUE_APP_CURRENT_MODE === 'local' ? process.env.VUE_APP_PROJECT_HOST : process.env.VUE_APP_GJW_PORTAL_URL
      const dest = ['OpenSpaceList', 'OpenFileList'].includes(this.$route.name)
        ? `${host}${process.env.VUE_APP_SUB_URL}#/signin?to=OpenSpaceList`
        : `${host}${process.env.VUE_APP_SUB_URL}#/signin`
      await this.logoutUserInfo({ dest: dest, platform: this.platform })
      if (this.platform !== 'web') {
        await this.logoutPlugin({ token: this.userToken })
        sessionStorage.setItem('isActiveLogout', 'true')
        DesktopCache.deleteFile(DesktopCache.loginCachePath())
        if (['OpenSpaceList', 'OpenFileList'].includes(this.$route.name)) {
          this.$router.replace({ name: 'Signin', query: { to: 'OpenSpaceList' }})
        } else {
          this.$router.replace({ name: 'Signin' })
        }
        localStorage.removeItem('anchor')
      }
    },
    returnHome() {
      if (['Index', 'OpenSpaceList'].includes(this.$route.name)) { return }
      if (['OpenFileList'].includes(this.$route.name)) {
        this.$router.replace({ name: 'OpenSpaceList', query: { to: 'OpenSpaceList' }})
        sessionStorage.removeItem('spaceName')
      } else {
        this.$router.replace({ name: 'Index' })
        sessionStorage.removeItem('spaceName')
      }
    },
    returnSpace() {
      const currentRouteName = this.$route.name
      const detailNames = Object.keys(this.resourceDetailMap)
      if (detailNames.includes(currentRouteName)) {
        const spaceNameRoute = this.resourceDetailMap[currentRouteName]
        this.$router.push({
          name: spaceNameRoute,
          params: { spaceId: this.$route.params.spaceId }
        })
      }
    },
    breadcrumbName(name) {
      if (!name) {
        return null
      }
      if (name.length <= 10) {
        return name
      } else {
        return name.substring(0, 10) + '...'
      }
    },

    async createGjwJsonFile() {
      const fileContent = {
        sharedCloudDisk: {
          localStorage: {
            consumingPath: this.defaultCachePath,
            storagePath: this.defaultCachePath
          }
        }
      }
      await DesktopCache.writeFile(DesktopCache.gjwJsonPath(), JSON.stringify(fileContent))
    },
    async getPluginCachePath() {
      // 读取当前缓存路径配置文件，若没有，则创建初始化配置文件
      const gjwJsonFile = DesktopCache.gjwJsonPath()
      const flag = await DesktopCache.checkExistFile(gjwJsonFile)
      if (flag === false) {
        this.setPluginCachePath(this.defaultCachePath)
        await this.createGjwJsonFile()
      } else {
        const fileContext = await DesktopCache.readFile(gjwJsonFile)
        if (fileContext && fileContext !== false) {
          const { sharedCloudDisk } = JSON.parse(fileContext)
          const cachePath = sharedCloudDisk.localStorage.storagePath || this.defaultCachePath
          this.setPluginCachePath(cachePath)
        } else {
          this.setPluginCachePath(this.defaultCachePath)
          await this.createGjwJsonFile()
        }
      }
    },
    showPluginSetting() {
      this.dialogVisible = true
      this.getPluginCachePath()
    },
    // 修改缓存路径
    async updateCache() {
      try {
        // 弹出路径选择对话框
        const { code, data } = await this.$desktopClient.SelectDirectory({ useFolderBrowserDialog: false })
        if (code === 'success' && data.selectedDirectory) {
          // 判断用户选择的路径是否合理
          const selectedDirectory = data.selectedDirectory
          if (selectedDirectory === this.pluginCachePath) {
            return
          }
          const isDirectoryEmptyRes = await this.$desktopClient.IsDirectoryEmpty(selectedDirectory)
          if (!isDirectoryEmptyRes.data) {
            this.$message.error('请选择空文件夹。')
            return
          }
          // 不能选择的路径：默认路径的父级、子级，原路径的子级。
          if (selectedDirectory === this.defaultCachePath || selectedDirectory.includes(`${this.defaultCachePath}\\`) || this.defaultCachePath.includes(`${selectedDirectory}\\`)) {
            this.$message.error('路径错误，不可选择系统默认路径，请重新选择。')
            return
          } else if (selectedDirectory.includes(`${this.pluginCachePath}\\`)) {
            this.$message.error('路径错误，不可选择原路径的子文件夹，请重新选择。')
            return
          }
          // 判断磁盘空间是否足够
          let directorySize = 0
          const directoryRes = await this.$desktopClient.GetDirectorySize(selectedDirectory)
          if (directoryRes.code === 'success' && directoryRes.data) {
            directorySize = new Big(directoryRes.data || 0)
          }
          if (directorySize) {
            this.$fullLoading.open('正在检查磁盘容量..')
            const driveRes = await this.$desktopClient.GetDriveInfo(selectedDirectory)
            this.$fullLoading.close()
            if (driveRes.code === 'success') {
              const size = driveRes.data || {}
              const driveTotalSize = new Big(size.totalSize || 0)
              const driveAvailableSize = new Big(size.availableSize || 0)
              const isEnough = driveAvailableSize.minus(directorySize).div(driveTotalSize).gt(0.1)
              if (!isEnough) {
                this.$confirm('空间不足，迁移失败。', {
                  cancelButtonText: '确定',
                  showConfirmButton: false,
                  showClose: false,
                  type: 'error',
                })
                return
              }
            }
          }

          // 新路径合理且磁盘空间足够，则启动文件迁移程序
          const startRes = await this.$desktopClient.StartMigration({
            srcPath: this.defaultCachePath,
            destPath: selectedDirectory,
            bannedProcesses: ['Gjw.Subprocess'],
            finishAction: {
              type: 'UpdateConfig',
              params: {
                configPath: DesktopCache.gjwJsonPath(),
                configItems: [
                  {
                    key: 'sharedCloudDisk.localStorage.storagePath',
                    value: selectedDirectory,
                  }
                ]
              }
            }
          })
          if (startRes.code === 'success') {
            if (startRes.data.status === 'ShortOut') {
              // 没有缓存文件，直接快速修改成功
              this.setPluginCachePath(selectedDirectory)
              this.$message.success('修改成功')
            }
          } else {
            this.$confirm('迁移程序唤起失败，请重试。', {
              confirmButtonText: '确定',
              showCancelButton: false,
              showClose: false,
              type: 'error',
            }).then(() => {})
          }
        }
      } catch (e) {
        this.$message.error('缓存路径修改失败')
      }
    },
    // 清理缓存
    clearCache() {
      this.$confirm(
        '是否确认清理所有已缓存的文件？注意：清理后所有来自云盘文件的本地链接将失效，请谨慎操作！',
        {
          confirmButtonText: '确定清理',
          cancelButtonText: '暂不清理',
          showClose: false,
          confirmButtonClass: 'clear-cache',
          type: 'warning',
        }
      ).then(() => {
        DesktopCache.deleteFiles(DesktopCache.businessPath(this.user.strId))
        this.startClearCacheProgress()
      }).catch(() => {})
    },
    startClearCacheProgress() {
      this.progressVisible = true
      this.clearCachePercentage = 0
      this.incrementProgress()
    },
    incrementProgress() {
      if (this.clearCachePercentage < 100) {
        const increment = 10
        this.clearCachePercentage += increment
        setTimeout(() => {
          if (this.clearCachePercentage < 100) {
            this.incrementProgress()
          } else {
            this.progressVisible = false
            setTimeout(() => {
              this.$confirm('清理成功！', {
                confirmButtonText: '确定',
                showClose: false,
                showCancelButton: false,
                type: 'success'
              }).then(() => {
                this.dialogVisible = false
                this.clearCachePercentage = 0
              }).catch(() => {})
            }, 300)
          }
        }, 200)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.svg-icon {
  width: 16px;
  height: 16px;
}
.text-no-wrap {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.header-web-index {
  background-image: url("~@/assets/img/bannner@2x.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 132px;
  .left {
    width: 1200px;
    margin: auto;
    padding: 16px 0;
    position: relative;
    color: #000;
    justify-content: space-between;
    .logo {
      height: 20px;
    }
    .seperator {
      margin: 0 8px;
      width: 1px;
      height: 16px;
      background-color: #d8d8d8;
    }
    .space-icon {
      width: 16px;
    }
  }
}
.header-client-index{
  height: 40px;
  border: 1px solid #d2d9e3;
  background: #f7f9fa;
  .left {
    width: 1200px;
    margin: auto;
    position: relative;
    color: #000;
    justify-content: space-between;
  }
}
.header {
  height: 40px;
  border: 1px solid #d2d9e3;
  background: #f7f9fa;
  .left {
    position: relative;
    width: 100%;
    margin: 0 10px;
    color: #000;
    justify-content: space-between;
    .logo {
      height: 30px;
    }
    .seperator {
      margin: 0 8px;
      width: 1px;
      height: 16px;
      background-color: #d8d8d8;
    }
    .space-icon {
      width: 16px;
    }
  }
}
.version-tag{
  padding: 1px 8px;
  border-radius: 2px;
  border: 1px solid #D9D9D9;
  background: #FAFAFA;
}
.enterprise-logo {
  display: flex;
  align-items: center;
}
.logo {
  margin-bottom: 30px;
  display: block;
}
.logo-title {
  font-size: 24px;
  color: #495f70;
}
.logo-img {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 18px;
  border-radius: 5px;
  width: 32px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  color: #495F70;
  &:hover {
    background-color: #dae0e8;
    cursor: pointer;
    color: @theme-color;
    .space-home {
      svg {
        fill: currentColor;
      }
    }
  }
  &.active-logo-img{
    color: @theme-color;
  }
  svg {
    width: 16px;
    height: 16px;
    fill: currentColor;
  }
}
.breadcrumb {
  margin-right: 10px;
  font-size: 14px;
  font-weight: normal;
  line-height: 22px;
  span {
    color: #495f70;
  }
}

.breadcrumbDetail {
  .spaceName {
    &:hover {
      cursor: pointer;
      color: @theme-color;
    }
  }
}

.right-header {
  position: relative;
  display: flex;
  align-items: center;
  .little-banner{
    height: 28px;
    margin-right: 6px;
  }
  .plugin-setting-container{
    display: flex;
    align-items: center;
    color: @text-tag-gery;
    border-radius: 4px;
    padding: 4px;
    margin-right: 6px;
    cursor: pointer;
    position: relative;
    &:hover {
      background: #DAE0E8;
    }
    &:after{
      content: '';
      position: absolute;
      top: 6px;
      right: -6px;
      width: 1px;
      height: 16px;
      background: #DAE0E8;
    }
    .icon-img {
      margin-right: 6px;
    }
  }
  .icon-container {
    display: flex;
    align-items: center;
    color: @text-tag-gery;
    margin: 0 10px 0 6px;
    .icon-item {
      border-radius: 4px;
      padding: 4px;
      cursor: pointer;
      &:hover {
        background: #DAE0E8;
      }
    }
    .icon-item + .icon-item{
      margin-left: 6px;
    }
  }
  .user-info {
    .user-avstar {
      width: 24px;
      height: 24px;
      opacity: 1;
      border-radius: 99px;
    }
    .user-brief-info {
      height: 100%;
      img {
        width: 24px;
        height: 24px;
        border-radius: 16px;
      }
      .user-name {
        display: inline-block;
        font-size: 14px;
        padding-left: 10px;
        line-height: 16px;
        height: 16px;
        max-width: 60px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #282832;
        cursor: default;
      }
    }
    .collapse-container {
      position: absolute;
      top: 100%;
      left: 0;
      border-radius: 2px;
      width: 240px;
      background-color: #fff;
      box-shadow: 0 2px 8px 1px rgba(0, 0, 0, 0.15);
      text-align: center;
    }
    .user-menu {
      position: absolute;
      right: 0;
      border-radius: 2px;
      z-index: 10000;
      background: white;
      color: @color-text-grey-4;
      box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12),
        0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 9px 28px 8px rgba(0, 0, 0, 0.05);
      .user-action {
        margin: 16px 0;
      }
      .user-info-menu-item {
        border-bottom: 1px solid #d2d9e3;
        min-width: 246px;
        min-height: 70px;
        font-size: 14px;
        line-height: 70px;
        padding: 0 16px;
        box-sizing: border-box;
        img {
          position: absolute;
          left: 18px;
          top: 18px;
          width: 40px;
          height: 40px;
          border-radius: 99px;
          opacity: 1;
          /* 自动布局 */
          display: flex;
          flex-direction: row;
          padding: 0;
        }
        .user-name {
          position: absolute;
          left: 73px;
          top: 18px;
          width: 28px;
          height: 20px;
          opacity: 1;

          font-family: Microsoft YaHei;
          font-size: 14px;
          font-weight: normal;
          line-height: 20px;
          text-align: left;
          display: flex;
          align-items: center;
          letter-spacing: 0;
          width: 165px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          display: block;
          /* 正文 */
          color: #495f70;
        }
        .user-mobile {
          position: absolute;
          left: 73px;
          top: 38px;
          width: 126px;
          height: 20px;
          opacity: 0.65;
          font-family: Microsoft YaHei;
          font-size: 12px;
          font-weight: normal;
          line-height: 20px;
          text-align: center;
          display: flex;
          align-items: center;
          letter-spacing: 0em;
          /* 辅助文字 */
          color: rgba(73, 95, 112, 0.6);
        }
      }
      .user-menu-item {
        min-width: 152px;
        min-height: 40px;
        font-size: 14px;
        line-height: 40px;
        padding: 0 26px;
        box-sizing: border-box;
        text-align: left;
        cursor: pointer;
        display: flex;
        align-items: center;
        &:hover {
          background: @color-fill-background;
          transition: all 0.3s;
        }
        a {
          color: inherit;
          display: block;
        }
        span {
          padding-left: 8px;
        }
      }
    }
    .user-detail {
      padding-top: 56px;
      position: relative;
      .collapse-user-name {
        padding: 16px 12px;
      }
      .role-tag {
        position: absolute;
        top: 16px;
        right: 16px;
        height: 22px;
        padding: 0 8px;
        color: #1890ff;
        border: 1px solid #91d5ff;
        background-color: #e6f7ff;
        &.role-tag-admin {
          color: #faad14;
          border: 1px solid #ffe58f;
          background-color: #fffbe6;
        }
      }
    }
    .log-out {
      height: 40px;
      line-height: 40px;
      border-top: 1px solid #d8d8d8;
      transition: all 0.3s;
      cursor: pointer;
      &:hover {
        background-color: #f0f0f0;
        color: @theme-color;
      }
    }
  }
}

.default-cache-path-container {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  span {
    flex: 0 0 100px;
    padding-right: 8px;
  }
  .el-button {
    margin-left: 10px;
  }
}
.tip{
  font-size: 12px;
  color: rgba(73, 95, 112, 0.8);
}

.progress-dialog {
  .progress-container {
    display: flex;
    align-items: baseline;
    span {
      padding-right: 10px;
    }
    .el-progress {
      flex: 1
    }
  }
  /deep/ .el-dialog__header {
    display: none;
  }
}
.feedback {
  width: 150px;
  height: 28px;
}
//.feedback {
//  color: #8892a0;
//  font-size: 16px;
//  cursor: pointer;
//  line-height: 24px;
//}
</style>
<style>
.el-message-box .el-message-box__btns .clear-cache {
  color: #ff4d4f;
  width: 88px;
  height: 32px;
  border: 1px solid #ff4d4f;
  border-radius: 2px;
  background: #ffffff;
  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.016);
}
</style>
